/**
 * Status da Tabela IBPT no card "Situação da tabela", calculado pela API do Motor Fiscal (não tem catálogo
 * no banco).
 */
export enum IbptStatusTabelaEnum {
    Atualizada = 1,
    VerificacaoPendente = 2,
    Atualizando = 3,
    SemTabela = 4,
}
